export interface ApiError {
  message: string;
  status?: number;
  isRateLimit?: boolean;
  retryAfter?: number;
}

export const handleApiError = (error: any): ApiError => {
  // Check if it's an axios error
  if (error.response) {
    const { status, data } = error.response;
    
    // Handle 429 Too Many Requests
    if (status === 429) {
      const retryAfter = error.response.headers['retry-after'];
      const retrySeconds = retryAfter ? parseInt(retryAfter, 10) : 60;
      
      return {
        message: `You've made too many requests. Please wait ${retrySeconds} seconds before trying again.`,
        status: 429,
        isRateLimit: true,
        retryAfter: retrySeconds
      };
    }
    
    // Handle other common HTTP errors
    switch (status) {
      case 400:
        return {
          message: data?.error || 'Invalid request. Please check your input and try again.',
          status: 400
        };
      case 401:
        return {
          message: data?.error || 'Authentication required. Please log in again.',
          status: 401
        };
      case 403:
        return {
          message: data?.error || 'Access denied. You don\'t have permission to perform this action.',
          status: 403
        };
      case 404:
        return {
          message: data?.error || 'The requested resource was not found.',
          status: 404
        };
      case 500:
        return {
          message: data?.error || 'Server error. Please try again later.',
          status: 500
        };
      case 502:
        return {
          message: data?.error || 'Service temporarily unavailable. Please try again later.',
          status: 502
        };
      case 503:
        return {
          message: data?.error || 'Service is temporarily down for maintenance. Please try again later.',
          status: 503
        };
      default:
        return {
          message: data?.error || `Request failed with status ${status}. Please try again.`,
          status
        };
    }
  }
  
  // Handle network errors
  if (error.request) {
    return {
      message: 'Network error. Please check your internet connection and try again.',
      status: 0
    };
  }
  
  // Handle other errors
  return {
    message: error.message || 'An unexpected error occurred. Please try again.',
    status: 0
  };
};

export const isRateLimitError = (error: any): boolean => {
  return error.response?.status === 429;
};

export const getRetryAfterSeconds = (error: any): number => {
  if (error.response?.status === 429) {
    const retryAfter = error.response.headers['retry-after'];
    return retryAfter ? parseInt(retryAfter, 10) : 60;
  }
  return 0;
}; 